export const isRemoveKeyPressed = (event: KeyboardEvent) => event.code === "Delete" || event.code === "Backspace";
